import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'cbre-table-title',
  styleUrls: ['./table-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <div class="cbre-table-title-container fx--h">
      <span class="cbre-table-title-container__title" *ngIf="title"> {{ title }} </span>
      <span *ngIf="count != null" class="cbre-table-title-container__count">
        {{ count }} <span class="cbre-table-title-container__count--semi-bold">Results</span>
      </span>
    </div>
  `,
})
export class TableTitleComponent {
  @Input() title = '';
  @Input() count!: number;
}
